
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kVx8h", function(module, exports) {

$parcel$export(module.exports, "register", () => $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf, (v) => $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf = v);
var $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf;
var $f3c2d4f5f568aeaa$export$f7ad0328861e2f03;
"use strict";
var $f3c2d4f5f568aeaa$var$mapping = new Map();
function $f3c2d4f5f568aeaa$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f3c2d4f5f568aeaa$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f3c2d4f5f568aeaa$var$resolve(id) {
    var resolved = $f3c2d4f5f568aeaa$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f3c2d4f5f568aeaa$export$6503ec6e8aabbaf = $f3c2d4f5f568aeaa$var$register;
$f3c2d4f5f568aeaa$export$f7ad0328861e2f03 = $f3c2d4f5f568aeaa$var$resolve;

});

var $28976cc11ca4a872$exports = {};

(parcelRequire("kVx8h")).register(new URL("", import.meta.url).toString(), JSON.parse('["58w94","07.47054bb1.js","hh2hS","../animals.a9e00e1d.png","l3eUY","01.660f2584.js","99yyr","01.bff02f15.js"]'));


var $lyoVb = parcelRequire("lyoVb");
let $2c85f4d8cae2da5e$var$img;
var $deb89cf557e04664$exports = {};
$deb89cf557e04664$exports = new URL("../animals.a9e00e1d.png", import.meta.url).toString();


const $2c85f4d8cae2da5e$var$imgUrl = new URL($deb89cf557e04664$exports);
function $2c85f4d8cae2da5e$export$513ccb98c53b8039() {
    $2c85f4d8cae2da5e$var$img = loadImage($2c85f4d8cae2da5e$var$imgUrl.href);
}
let $2c85f4d8cae2da5e$var$palette;
let $2c85f4d8cae2da5e$var$skew;
function $2c85f4d8cae2da5e$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
    $2c85f4d8cae2da5e$var$palette = $2c85f4d8cae2da5e$var$convertRGBtoHSL($2c85f4d8cae2da5e$var$getPalette()).filter((c)=>c.l > 20);
    $2c85f4d8cae2da5e$var$skew = Math.floor(noise(PI) * 10);
    console.log($2c85f4d8cae2da5e$var$skew);
    background(20, 40, 10);
}
// https://github.com/zygisS22/color-palette-extraction/blob/master/index.js
// MIT License
// Copyright (c) 2022 Zygimantas Sniurevicius
function $2c85f4d8cae2da5e$var$getPalette() {
    $2c85f4d8cae2da5e$var$img.loadPixels();
    const rgbArray = [];
    for(let i = 0; i < $2c85f4d8cae2da5e$var$img.pixels.length; i += 4){
        const rgb = {
            r: $2c85f4d8cae2da5e$var$img.pixels[i],
            g: $2c85f4d8cae2da5e$var$img.pixels[i + 1],
            b: $2c85f4d8cae2da5e$var$img.pixels[i + 2]
        };
        rgbArray.push(rgb);
    }
    const findBiggestColorRange = (rgbValues)=>{
        let rMin = Number.MAX_VALUE;
        let gMin = Number.MAX_VALUE;
        let bMin = Number.MAX_VALUE;
        let rMax = Number.MIN_VALUE;
        let gMax = Number.MIN_VALUE;
        let bMax = Number.MIN_VALUE;
        rgbValues.forEach((pixel)=>{
            rMin = Math.min(rMin, pixel.r);
            gMin = Math.min(gMin, pixel.g);
            bMin = Math.min(bMin, pixel.b);
            rMax = Math.max(rMax, pixel.r);
            gMax = Math.max(gMax, pixel.g);
            bMax = Math.max(bMax, pixel.b);
        });
        const rRange = rMax - rMin;
        const gRange = gMax - gMin;
        const bRange = bMax - bMin;
        const biggestRange = Math.max(rRange, gRange, bRange);
        if (biggestRange === rRange) return "r";
        else if (biggestRange === gRange) return "g";
        else return "b";
    };
    const quantization = (rgbValues, depth)=>{
        const MAX_DEPTH = 4;
        // Base case
        if (depth === MAX_DEPTH || rgbValues.length === 0) {
            const color = rgbValues.reduce((prev, curr)=>{
                prev.r += curr.r;
                prev.g += curr.g;
                prev.b += curr.b;
                return prev;
            }, {
                r: 0,
                g: 0,
                b: 0
            });
            color.r = Math.round(color.r / rgbValues.length);
            color.g = Math.round(color.g / rgbValues.length);
            color.b = Math.round(color.b / rgbValues.length);
            return [
                color
            ];
        }
        /**
	 *  Recursively do the following:
	 *  1. Find the pixel channel (red,green or blue) with biggest difference/range
	 *  2. Order by this channel
	 *  3. Divide in half the rgb colors list
	 *  4. Repeat process again, until desired depth or base case
	 */ const componentToSortBy = findBiggestColorRange(rgbValues);
        rgbValues.sort((p1, p2)=>{
            return p1[componentToSortBy] - p2[componentToSortBy];
        });
        const mid = rgbValues.length / 2;
        return [
            ...quantization(rgbValues.slice(0, mid), depth + 1),
            ...quantization(rgbValues.slice(mid + 1), depth + 1)
        ];
    };
    const quantColors = quantization(rgbArray, 0);
    return quantColors;
}
// https://github.com/zygisS22/color-palette-extraction/blob/master/index.js
// MIT License
// Copyright (c) 2022 Zygimantas Sniurevicius
function $2c85f4d8cae2da5e$var$convertRGBtoHSL(rgbValues) {
    /**
	 * Convert RGB values to HSL
	 * This formula can be
	 * found here https://www.niwa.nu/2013/05/math-behind-colorspace-conversions-rgb-hsl/
	 */ return rgbValues.map((pixel)=>{
        let hue, saturation, luminance = 0;
        // first change range from 0-255 to 0 - 1
        let redOpposite = pixel.r / 255;
        let greenOpposite = pixel.g / 255;
        let blueOpposite = pixel.b / 255;
        const Cmax = Math.max(redOpposite, greenOpposite, blueOpposite);
        const Cmin = Math.min(redOpposite, greenOpposite, blueOpposite);
        const difference = Cmax - Cmin;
        luminance = (Cmax + Cmin) / 2.0;
        if (luminance <= 0.5) saturation = difference / (Cmax + Cmin);
        else if (luminance >= 0.5) saturation = difference / (2.0 - Cmax - Cmin);
        /**
		 * If Red is max, then Hue = (G-B)/(max-min)
		 * If Green is max, then Hue = 2.0 + (B-R)/(max-min)
		 * If Blue is max, then Hue = 4.0 + (R-G)/(max-min)
		 */ const maxColorValue = Math.max(pixel.r, pixel.g, pixel.b);
        if (maxColorValue === pixel.r) hue = (greenOpposite - blueOpposite) / difference;
        else if (maxColorValue === pixel.g) hue = 2.0 + (blueOpposite - redOpposite) / difference;
        else hue = 4.0 + (greenOpposite - blueOpposite) / difference;
        hue = hue * 60; // find the sector of 60 degrees to which the color belongs
        // it should be always a positive angle
        if (hue < 0) hue = hue + 360;
        // When all three of R, G and B are equal, we get a neutral color: white, grey or black.
        if (difference === 0) return false;
        return {
            h: Math.round(hue) + 180,
            s: parseFloat(saturation * 100).toFixed(2),
            l: parseFloat(luminance * 100).toFixed(2)
        };
    });
}
const $2c85f4d8cae2da5e$var$num = 80;
function $2c85f4d8cae2da5e$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    background(100);
    noStroke();
    for(let x0 = 0; x0 < 10; x0++)for(let y0 = 0; y0 < 10; y0++){
        const c = $2c85f4d8cae2da5e$var$palette[(x0 + y0 + $2c85f4d8cae2da5e$var$skew * y0) % $2c85f4d8cae2da5e$var$palette.length];
        fill(...[
            c.h,
            c.s,
            c.l
        ]);
        rect((0, $lyoVb.w)(x0 / 10), (0, $lyoVb.h)(y0 / 10), (0, $lyoVb.w)(0.1), (0, $lyoVb.h)(0.1));
    }
    const frameN = frameCount % 600 / 600;
    for(let x0 = 0; x0 < $2c85f4d8cae2da5e$var$num; x0++)for(let y0 = 0; y0 < $2c85f4d8cae2da5e$var$num; y0++){
        const n = noise(x0 * 2.1, y0 * 3.05) * 2 - 1;
        const x = (x0 + 0.5) / $2c85f4d8cae2da5e$var$num + n * 0.01;
        const y = (y0 + 0.5) / $2c85f4d8cae2da5e$var$num + n * 0.01;
        const r0 = 0.0065;
        const n1 = dist(x, y, 0.5, 0.5) * PI;
        const ny = dist(x, y, 0.5 + 0.2 * Math.cos(TAU * frameN * 3 + QUARTER_PI + n1), 0.5 + 0.2 * Math.sin(TAU * frameN * 3 + QUARTER_PI + n1)) * 1 * TAU;
        const r = r0 + 0.002 * Math.sin(frameN * -5 * TAU + ny * 3);
        const c0 = Math.floor($2c85f4d8cae2da5e$var$palette.length * noise(x, y) * 150) % $2c85f4d8cae2da5e$var$palette.length;
        const c = $2c85f4d8cae2da5e$var$palette[c0];
        fill(...[
            c.h,
            c.s,
            c.l
        ]);
        ellipse((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(r));
    }
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $0e4e50a4ef9959b0$var$source = 'import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frame,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from \'../js/common.js\';\n\nlet img;\nconst imgUrl = new URL(\'./animals.png\', import.meta.url);\nexport function preload() {\n	img = loadImage(imgUrl.href);\n}\n\nlet palette;\nlet skew;\nexport function setup() {\n	setupCommon();\n\n	palette = convertRGBtoHSL(getPalette())\n		.filter(c => c.l > 20);\n\n	skew = Math.floor(noise(PI) * 10);\n	console.log(skew);\n\n	background(20, 40, 10);\n}\n\n// https://github.com/zygisS22/color-palette-extraction/blob/master/index.js\n// MIT License\n// Copyright (c) 2022 Zygimantas Sniurevicius\nfunction getPalette() {\n	img.loadPixels();\n	const rgbArray = [];\n	for (let i = 0; i < img.pixels.length; i += 4) {\n		const rgb = {\n			r: img.pixels[i],\n			g: img.pixels[i + 1],\n			b: img.pixels[i + 2],\n		};\n		rgbArray.push(rgb);\n	}\n\n	const findBiggestColorRange = (rgbValues) => {\n		let rMin = Number.MAX_VALUE;\n		let gMin = Number.MAX_VALUE;\n		let bMin = Number.MAX_VALUE;\n\n		let rMax = Number.MIN_VALUE;\n		let gMax = Number.MIN_VALUE;\n		let bMax = Number.MIN_VALUE;\n\n		rgbValues.forEach((pixel) => {\n			rMin = Math.min(rMin, pixel.r);\n			gMin = Math.min(gMin, pixel.g);\n			bMin = Math.min(bMin, pixel.b);\n\n			rMax = Math.max(rMax, pixel.r);\n			gMax = Math.max(gMax, pixel.g);\n			bMax = Math.max(bMax, pixel.b);\n		});\n\n		const rRange = rMax - rMin;\n		const gRange = gMax - gMin;\n		const bRange = bMax - bMin;\n\n		const biggestRange = Math.max(rRange, gRange, bRange);\n		if (biggestRange === rRange) {\n			return "r";\n		} else if (biggestRange === gRange) {\n			return "g";\n		} else {\n			return "b";\n		}\n	};\n\n	const quantization = (rgbValues, depth) => {\n		const MAX_DEPTH = 4;\n\n		// Base case\n		if (depth === MAX_DEPTH || rgbValues.length === 0) {\n			const color = rgbValues.reduce(\n				(prev, curr) => {\n					prev.r += curr.r;\n					prev.g += curr.g;\n					prev.b += curr.b;\n\n					return prev;\n				},\n				{\n					r: 0,\n					g: 0,\n					b: 0,\n				}\n			);\n\n			color.r = Math.round(color.r / rgbValues.length);\n			color.g = Math.round(color.g / rgbValues.length);\n			color.b = Math.round(color.b / rgbValues.length);\n\n			return [color];\n		};\n\n		/**\n	 *  Recursively do the following:\n	 *  1. Find the pixel channel (red,green or blue) with biggest difference/range\n	 *  2. Order by this channel\n	 *  3. Divide in half the rgb colors list\n	 *  4. Repeat process again, until desired depth or base case\n	 */\n		const componentToSortBy = findBiggestColorRange(rgbValues);\n		rgbValues.sort((p1, p2) => {\n			return p1[componentToSortBy] - p2[componentToSortBy];\n		});\n\n		const mid = rgbValues.length / 2;\n		return [\n			...quantization(rgbValues.slice(0, mid), depth + 1),\n			...quantization(rgbValues.slice(mid + 1), depth + 1),\n		];\n	};\n\n	const quantColors = quantization(rgbArray, 0);\n	return quantColors;\n}\n\n// https://github.com/zygisS22/color-palette-extraction/blob/master/index.js\n// MIT License\n// Copyright (c) 2022 Zygimantas Sniurevicius\nfunction convertRGBtoHSL(rgbValues) {\n	/**\n	 * Convert RGB values to HSL\n	 * This formula can be\n	 * found here https://www.niwa.nu/2013/05/math-behind-colorspace-conversions-rgb-hsl/\n	 */\n	return rgbValues.map((pixel) => {\n		let hue,\n			saturation,\n			luminance = 0;\n\n		// first change range from 0-255 to 0 - 1\n		let redOpposite = pixel.r / 255;\n		let greenOpposite = pixel.g / 255;\n		let blueOpposite = pixel.b / 255;\n\n		const Cmax = Math.max(redOpposite, greenOpposite, blueOpposite);\n		const Cmin = Math.min(redOpposite, greenOpposite, blueOpposite);\n\n		const difference = Cmax - Cmin;\n\n		luminance = (Cmax + Cmin) / 2.0;\n\n		if (luminance <= 0.5) {\n			saturation = difference / (Cmax + Cmin);\n		} else if (luminance >= 0.5) {\n			saturation = difference / (2.0 - Cmax - Cmin);\n		}\n\n		/**\n		 * If Red is max, then Hue = (G-B)/(max-min)\n		 * If Green is max, then Hue = 2.0 + (B-R)/(max-min)\n		 * If Blue is max, then Hue = 4.0 + (R-G)/(max-min)\n		 */\n		const maxColorValue = Math.max(pixel.r, pixel.g, pixel.b);\n\n		if (maxColorValue === pixel.r) {\n			hue = (greenOpposite - blueOpposite) / difference;\n		} else if (maxColorValue === pixel.g) {\n			hue = 2.0 + (blueOpposite - redOpposite) / difference;\n		} else {\n			hue = 4.0 + (greenOpposite - blueOpposite) / difference;\n		}\n\n		hue = hue * 60; // find the sector of 60 degrees to which the color belongs\n\n		// it should be always a positive angle\n		if (hue < 0) {\n			hue = hue + 360;\n		}\n\n		// When all three of R, G and B are equal, we get a neutral color: white, grey or black.\n		if (difference === 0) {\n			return false;\n		}\n\n		return {\n			h: Math.round(hue) + 180, // plus 180 degrees because that is the complementary color\n			s: parseFloat(saturation * 100).toFixed(2),\n			l: parseFloat(luminance * 100).toFixed(2),\n		};\n	});\n}\n\nconst num = 80;\nexport function draw() {\n	drawCommon();\n	background(100);\n\n	noStroke();\n	for (let x0 = 0; x0 < 10; x0++) {\n		for (let y0 = 0; y0 < 10; y0++) {\n			const c = palette[(x0 + y0 + skew * y0) % palette.length];\n			fill(...[c.h, c.s, c.l]);\n			rect(w(x0 / 10), h(y0 / 10), w(1 / 10), h(1 / 10));\n		}\n	}\n\n	const frameN = (frameCount % 600) / 600;\n	for (let x0 = 0; x0 < num; x0++) {\n		for (let y0 = 0; y0 < num; y0++) {\n			const n = noise(x0 * 2.1, y0 * 3.05) * 2 - 1;\n			const x = (x0 + 0.5) / num + n * 0.01;\n			const y = (y0 + 0.5) / num + n * 0.01;\n\n			const r0 = 0.0065;\n\n			const n1 = dist(x, y, 0.5, 0.5) * PI;\n			const ny = dist(x, y,\n				0.5 + 0.2 * Math.cos(TAU * frameN * 3 + QUARTER_PI + n1),\n				0.5 + 0.2 * Math.sin(TAU * frameN * 3 + QUARTER_PI + n1)) * 1 * TAU;\n			const r = r0 + 0.002 * Math.sin(frameN * -5 * TAU + ny * 3);\n\n			const c0 = Math.floor(palette.length * noise(x, y) * 150) % palette.length;\n			const c = palette[c0];\n			fill(...[c.h, c.s, c.l]);\n			ellipse(w(x), h(y), w(r));\n		}\n	}\n}\n';
(0, $gPx2I.make)({
    setup: $2c85f4d8cae2da5e$export$de27182ff8187d6c,
    draw: $2c85f4d8cae2da5e$export$e529deb2bfd496dc,
    preload: $2c85f4d8cae2da5e$export$513ccb98c53b8039
}, $0e4e50a4ef9959b0$var$source);


//# sourceMappingURL=07.47054bb1.js.map
